export type ISOFormatLocalDateTime = string

export interface AvailableTime {
  startTime: string
  endTime: string
}
export type Week = 'monday' | 'tuesday' | 'wednesday' | 'thursday' | 'friday' | 'saturday' | 'sunday'
export type AvailableTimes = AvailableTime[]
export type AvailableTimesByDay = Record<Week, AvailableTimes>
export interface ReservationCategory {
  id: number
  name: string
  hospitalId: number
  eventIds: number[] // default []
  availableTimes: AvailableTimesByDay
  durationMinutes: number // 15, 30, 60, 90, 120, 150
  thresholdCount: number // 1 ~ 256
  crmConfiguration: {
    categoryId: string | null // null: categoryId가 없는 경우
  }
}
export interface ReservationEventSetting {
  id: number
  hospitalId: number
  eventId: number
  reservationType: 'WAITING' | 'IMMEDIATE' | 'NONE' // 'WAITING'(대기예약) | 'IMMEDIATE'(확정예약)
  isOnAir: boolean
  categories: ReservationCategory[]
}

export enum ReservationStatusCodes {
  PartialSuccess = 'PartialSuccess', // 상담 - 예약 - CRM 생성 플로우에서 일부만 성공한 경우
  Success = 'Success', // 서버에 command한 요청이 모두 성공한 경우
}
export interface ReservationWrapped<Payload = unknown> {
  code: ReservationStatusCodes
  payload?: Payload
}
export interface MakeReservationSuccessResponse {
  afPoint: number
  consultationId: number
}
export interface ErrorResponse {
  message: string
}

export interface MakeReservationKrCommand {
  progressId: string
  memberId: number
  slotId: number
  serviceOfferId: number
  serviceOfferTitle: string
  memberName: string
  memberPhoneNational: string
  memberPhoneCountryCode: string
  memberEmail: string
  memberBirthYear: number
}

export interface MakeReservationJpCommand {
  hospitalId: number
  slotId: number
  requestedReservedAt: string
  userInfo: {
    name: string
    phoneNational: string // 1012345678
    birthYear: number
    birthMonth?: number
    birthDay?: number
    sex: 'MALE' | 'FEMALE' | 'ANY'
    email: string
    deviceType: string
    treatmentExperience?: string
  }
  origin: {
    type: 'EVENT'
    id: number
  }
}

export interface MakeReservationJpSuccessResponse {
  consultationId: number
  createdAt: ISOFormatLocalDateTime
  eventId: number
  hospitalId: number
  id: number
  memberEmail: string
  memberId: number
  memberName: string
  memberPhoneNumber: string
  reservedAt: ISOFormatLocalDateTime
  slotId: number
  state: string
  updateCount: number
  updatedAt: ISOFormatLocalDateTime
}

export interface TryReservationCommand {
  progressId: string
  hospitalId: number
  serviceOfferId: number
  memberName: string
  memberPhoneCountryCode: string
  memberPhoneNational: string
  memberEmail: string
  requestedReservedAt?: string
  slotId?: number
}

export interface ChangeReservationTimeCommand {
  reservationId: number
  slotId: number
  eventTitle?: string
  /** 4자리 수의 연도 표현, 예)1995 */
  birthYear?: number
  startDateTimeUtc: string
  endDateTimeUtc: string
}
